import axios from "axios";

const http = axios.create({
    baseURL: "https://api.ayur.technexs.com/ayu",
    headers: {
        "Content-Type": "application/json",
    },
});

let tokenPromise = null;

const fetchAccessToken = async () => {
    try {
        const response = await http.get(
            "/oauth/token?userId=ayuadm%40gmail.com&password=VGVzdEAxMjM%3D"
        );

        const { access_token } = response.data;

        localStorage.setItem("access_token", access_token);

        return access_token;
    } catch (error) {
        console.error("Error fetching access token:", error);
        throw error;
    }
};

const getAccessToken = async () => {
    const existingToken = localStorage.getItem("access_token");

    if (existingToken) {
        return existingToken;
    }

    // If token request is already running,
    // wait for the same request instead of creating another one.
    if (!tokenPromise) {
        tokenPromise = fetchAccessToken().finally(() => {
            tokenPromise = null;
        });
    }

    return tokenPromise;
};

http.interceptors.request.use(
    async (config) => {
        // Don't add Authorization to token API itself
        if (config.url?.includes("/oauth/token")) {
            return config;
        }

        const token = await getAccessToken();

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

export default http;